export default {
  label: '生产技术主管',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '生产技术主管负责矿山生产现场的管理，制定并执行工艺操作规范',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '解决生产过程中出现的问题，分析异常情况并提出改进措施',
          id: '0-2-1',
        },
        {
          label: '制定车间生产计划，确保产量目标达成',
          id: '0-2-2'
        },
        {
          label: '建立和完善生产现场质量管理体系',
          id: '0-2-3'
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备扎实的专业知识和业务技能，沟通能力强',
          id: '0-3-1',
        },
        {
          label: '能够协调各部门关系，提高生产效率和质量',
          id: '0-3-2',
        }
      ],
    },
    {
      label: '薪资水平',
      id: '0-4',
      children: [
        {
          label: '煤矿安全管理：5000-15000元/月',
          id: '0-4-1',
        }
      ],
    },
    {
      label: '晋升方向',
      id: '0-5',
      children: [
        {
          label: '矿山经理',
          id: '0-5-1',
        },
        {
          label: '采矿总工程师',
          id: '0-5-2',
        },
        {
          label: '采矿资深专家',
          id: '0-5-3',
        }
      ],
    }
  ],
};